module.exports = __webpack_public_path__ + "assets/img/current-icon.1ec44199.png";